@switch (columnName) {
  @case ('edit') {
    <app-ui-button
      buttonType="icon-button"
      icon="edit"
      [ariaLabel]="'edit' | translate"
      (click)="buttonFunctions.edit()"
      [disabled]="!hasUpdatePermission"
      [tooltip]="hasUpdatePermission ? '' : ('noAccess' | translate)"
    ></app-ui-button>
  }
  @case ('delete') {
    <app-ui-button
      buttonType="icon-button"
      icon="delete"
      [ariaLabel]="'delete' | translate"
      (click)="buttonFunctions.delete()"
      [disabled]="!hasDeletePermission"
      [tooltip]="hasDeletePermission ? '' : ('noAccess' | translate)"
    ></app-ui-button>
  }
  @case ('actionDoneBy') {
    <div class="row align-items-center">
      <mat-icon>perm_identity</mat-icon>
      <p class="text">{{ element.actionDoneBy | fullName }}</p>
    </div>
  }
  @case ('actionDoneAt') {
    {{ element.actionDoneAt | date: dateTimeFormat }}
  }
  @case ('nextExpiry') {
    {{ element.nextExpiry | date }}
  }
  @case ('lastPerformed') {
    {{ element.lastPerformed | date: dateTimeFormat }}
  }
  @case ('intervalDays') {
    @if (intervalDays !== null && intervalDays !== undefined) {
      {{ intervalDays }}
    } @else {
      -
    }
  }
  @case ('action') {
    {{ element.action | mapRiskAssessmentAction | translate }}
  }
  @case ('view') {
    @if (
      element.action === RiskAssessmentAction.Perform ||
      element.action === RiskAssessmentAction.EditAndPerform
    ) {
      <app-ui-button
        buttonType="secondary"
        text="{{ 'view' | translate }}"
        [routerLink]="UserRiskAssessmentRoutes.Overview + '/' + id + '/version/' + element.id"
      ></app-ui-button>
    }
  }
  @case ('createFromTemplate') {
    <app-ui-button
      class="create-from-template-button"
      buttonType="secondary"
      [routerLink]="UserRiskAssessmentRoutes.Template + '/' + element.id"
      icon="add"
      text=""
      tooltipClass="tooltip"
      [disabled]="!hasCreatePermimssion"
      [tooltip]="
        hasCreatePermimssion
          ? ('createRiskAssessmentFromTemplateDescription' | translate)
          : ('noAccess' | translate)
      "
    ></app-ui-button>
  }
  @case ('status') {
    <app-ui-pill [name]="ALERT_STATUS_TITLES[element[columnName]]"></app-ui-pill>
  }
  @case ('id') {
    {{ element.riskAssessmentId }}
  }
  @case ('access') {
    <app-positions-cell [element]="element"></app-positions-cell>
  }
  @case ('responsible') {
    @for (position of element.responsibleForPositions ?? []; track $index) {
      <app-text-overflow-label [text]="position.name"></app-text-overflow-label>
    }
    @for (positionGroup of element.responsibleForPositionGroups ?? []; track $index) {
      <app-text-overflow-label [text]="positionGroup.name"></app-text-overflow-label>
    }
    @for (role of element.responsibleForRoles ?? []; track $index) {
      <app-text-overflow-label [text]="role.name"></app-text-overflow-label>
    }
  }
  @case ('maxInitialRisk') {
    @if (getMaxRiskDisplayValue(element.maxInitialRisk) !== null) {
      <span
        class="ra-risk-badge"
        [ngClass]="{ 'ra-risk-outline': maxInitialRiskColor === null }"
        [style.background-color]="
          maxInitialRiskColor != null ? RA_RISK_COLOR_HEX[maxInitialRiskColor] : null
        "
      >
        {{ getMaxRiskDisplayValue(element.maxInitialRisk) }}
      </span>
    }
  }
  @case ('maxResidualRisk') {
    @if (getMaxRiskDisplayValue(element.maxResidualRisk) !== null) {
      <span
        class="ra-risk-badge"
        [ngClass]="{ 'ra-risk-outline': maxResidualRiskColor === null }"
        [style.background-color]="
          maxResidualRiskColor != null ? RA_RISK_COLOR_HEX[maxResidualRiskColor] : null
        "
      >
        {{ getMaxRiskDisplayValue(element.maxResidualRisk) }}
      </span>
    }
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
